import {createWebHistory, createRouter} from 'vue-router'
import IndexN from './components/pic_bn/IndexN'
import DemoN from './components/pic_bn/DemoN'
import FaqN from './components/pic_bn/FaqN'
import QrCodeN from './components/pic_bn/QrCodeN'
// import StoreN from './components/pic_bn/StoreN'
import ContactsN from './components/pic_bn/ContactsN'
import CodeN from './components/pic_bn/CodeN'
import PdfN from './components/pic_bn/PdfN'
import QrCodeGenerateN from './components/pic_bn/QrCodeGenerateN'

const routes = [
    {
        path: '/',
        component: IndexN
    },
    {
        path: '/demo',
        component: DemoN
    },
    {
        path: '/faq',
        component: FaqN
    },
    {
        path: '/qr_code',
        component: QrCodeN
    },
    // {
    //     path: '/store',
    //     component: StoreN
    // },
    {
        path: '/contacts',
        component: ContactsN
    },
    {
        path: '/qr',
        component: CodeN
    },
    {
        path: '/instruction/:qr_code',
        component: PdfN
    },
    {
        path: '/generation/:qr_code',
        component: QrCodeGenerateN
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;